import React, { useState } from "react"
import qs from "query-string"
import get from "lodash/get"
import Map from "../map"
import Layout from "../layout"
import SEO from "../seo"

import PoisGrid from "./grid"
import PoisFilter from "./filter"

const getSearchType = (location, availableTypes) => {
  const { search } = location
  const queryType = qs.parse(search) ? qs.parse(search).query : false
  const isType = availableTypes.includes(queryType)

  return (isType && queryType) || false
}

const Pois = ({ title, data, location }) => {
  const meta = get(data, "site.siteMetadata")
  const pois = get(data, "allContentfulPoi.nodes", [])
  const availableTypes = [...new Set(pois.map(poi => poi.type))]
  const searchType = getSearchType(location, availableTypes)
  const [selectedTypes, setSelectedTypes] = useState(
    searchType ? [searchType] : availableTypes
  )
  const filteredPois = pois.filter(({ type }) => selectedTypes.includes(type))
  const filteredPositions = filteredPois
    .map(
      ({ title, location }) =>
        location && { title, position: [location.lat, location.lon] }
    )
    .filter(Boolean)

  const mapLocations = [
    { title: meta.title, position: meta.house },
    ...filteredPositions,
  ]

  const poiTitles = filteredPois
    .map(({ title }) => title.toLowerCase())
    .join(', ')

  const keywords = filteredPois ?
    `nearby, in de buurt, poi, places, plaaten, wat te doen, what to do, ${title}, ${poiTitles}` :
    `nearby, in de buurt, poi, places, plaaten, wat te doen, what to do, ${title}`

  return (
    <>
      <SEO title={title} keywords={keywords} />
      <Layout>
        <section className="mb-8">
          <Map locations={mapLocations} />
        </section>

        <section>
          <h1 className="mb-4">
            {title} ({filteredPois.length})
          </h1>

          <div className="mb-8">
            <PoisFilter
              availableTypes={availableTypes}
              selectedTypes={selectedTypes}
              setSelectedTypes={setSelectedTypes}
            />
          </div>

          <PoisGrid pois={filteredPois} />
        </section>
      </Layout>
    </>
  )
}

Pois.defaultProps = {
  title: "Pois",
}

export default Pois
